import { useTranslation } from "react-i18next";
import { Button, Spin, Typography } from "@arco-design/web-react";

import { useFetchVersionList } from "../../api/hooks/useFetchVersion";
import { useCurrentLanguage } from "../../utils/hooks/useCurrentLanguage";
import { formatReleaseDate } from "./versionPageUtils";
import { useVersionNavigation, VersionPageShell } from "./VersionPageShell";
import "./Version.css";

export const VersionList = () => {
  const { t } = useTranslation();
  const currentLanguage = useCurrentLanguage();
  const { exitToApp, goToDetail } = useVersionNavigation();
  const { data, isLoading, isError, refetch } = useFetchVersionList();

  return (
    <VersionPageShell onBack={exitToApp}>
      <div className="version-page__hero">
        <Typography.Title heading={3} className="version-page__version">
          {t("version_page.history_title")}
        </Typography.Title>
      </div>

      {isLoading && (
        <div className="version-page__loading">
          <Spin size={32} />
        </div>
      )}

      {isError && (
        <div className="version-page__error">
          <p>{t("version_page.error_message")}</p>
          <Button className="version-page__retry" onClick={() => refetch()}>
            {t("version_page.retry_button")}
          </Button>
        </div>
      )}

      {data && !isLoading && (
        <div className="version-page__release-list">
          {(data.releases ?? []).map((release, index) => (
            <button
              key={release.version}
              type="button"
              className="version-page__release-row"
              onClick={() => goToDetail(release.version)}
            >
              <div className="version-page__release-main">
                <span className="version-page__release-version">v{release.version}</span>
                {index === 0 && (
                  <span className="version-page__release-badge">{t("version_page.latest_badge")}</span>
                )}
              </div>
              <div className="version-page__release-meta">
                {release.releaseDate && (
                  <span className="version-page__release-date">
                    {formatReleaseDate(release.releaseDate, currentLanguage)}
                  </span>
                )}
                <span className="version-page__release-arrow" aria-hidden="true">
                  →
                </span>
              </div>
            </button>
          ))}
        </div>
      )}
    </VersionPageShell>
  );
};
